import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IllustrationErrorSvg } from "./IllustrationErrorSvg.mjs";
const IllustrationError = () => /* @__PURE__ */ jsx(Box, { component: IllustrationErrorSvg });
export {
  IllustrationError
};
